import React from 'react';
import { motion } from 'framer-motion';
import { cvData } from '../data/cvData';
import { uiTranslations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import SectionHeader from './SectionHeader';
import SafeIcon from '../common/SafeIcon';

export default function Contact() {
  const { language } = useLanguage();
  const data = cvData[language];
  const t = uiTranslations[language].sections.contact;
  const labels = uiTranslations[language].contact;
  const { email, phone, location } = data.personal;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;

  return (
    <section id="contact" className="py-24 bg-surface">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <SectionHeader title={t.title} label={t.label} />
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.5, delay: 0.1 }} 
          className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-slate-100 flex flex-col md:flex-row justify-start items-center md:items-start gap-8 md:gap-16"
        >
          {/* E-Mail */}
          <a href={`mailto:${email}`} className="flex flex-col items-center md:items-start group transition-all">
            <div className="w-12 h-12 bg-primary/5 text-primary rounded-full flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-white transition-colors">
              <SafeIcon name="Mail" className="w-5 h-5" />
            </div>
            <span className="text-slate-600 font-medium group-hover:text-slate-900 transition-colors">{email}</span>
            <span className="text-sm text-slate-400 mt-1">{labels.emailLabel}</span>
          </a>

          <div className="hidden md:block w-px h-16 bg-slate-200 self-center"></div>

          {/* Telefon */}
          <a href={`tel:${phone.replace(/\s/g, '')}`} className="flex flex-col items-center md:items-start group transition-all">
            <div className="w-12 h-12 bg-primary/5 text-primary rounded-full flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-white transition-colors">
              <SafeIcon name="Phone" className="w-5 h-5" />
            </div>
            <span className="text-slate-600 font-medium group-hover:text-slate-900 transition-colors">{phone}</span>
            <span className="text-sm text-slate-400 mt-1">{labels.phoneLabel}</span>
          </a>

          <div className="hidden md:block w-px h-16 bg-slate-200 self-center"></div>

          {/* Standort */}
          <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center md:items-start group transition-all">
            <div className="w-12 h-12 bg-primary/5 text-primary rounded-full flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-white transition-colors">
              <SafeIcon name="MapPin" className="w-5 h-5" />
            </div>
            <span className="text-slate-600 font-medium group-hover:text-slate-900 transition-colors">
              {location}
            </span>
            <span className="text-sm text-slate-400 mt-1 group-hover:text-slate-500 transition-colors">
              {labels.mapLabel}
            </span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}